import React, { useEffect, useState } from 'react';
import { useUsageTracking } from '../hooks/useUsageTracking';
import UsageBlurOverlay from './UsageBlurOverlay';

const UsageGuard = ({
  children,
  feature,
  featureName,
  trackOnMount = true,
  onLimitReached,
}) => {
  const {
    loading,
    usage,
    isExceeded,
    isUnlimited,
    lastReset,
    trackUsage
  } = useUsageTracking(feature);

  const [showOverlay, setShowOverlay] = useState(false);
  const [hasTracked, setHasTracked] = useState(false);

  useEffect(() => {
    const performTracking = async () => {
      if (trackOnMount && !hasTracked && !loading && !isUnlimited) {
        const result = await trackUsage();
        setHasTracked(true);

        if (result.exceeded) {
          setShowOverlay(true);
          onLimitReached?.();
        }
      }
    };

    performTracking();
  }, [trackOnMount, hasTracked, loading, isUnlimited, trackUsage, onLimitReached]);

  useEffect(() => {
    if (!loading && isExceeded) {
      setShowOverlay(true);
      onLimitReached?.();
    }
  }, [loading, isExceeded, onLimitReached]);

  if (isUnlimited) {
    return <>{children}</>;
  }

  return (
    <div className={showOverlay ? 'relative w-full h-full overflow-hidden' : 'relative w-full h-full'}>
      <div className={showOverlay ? 'filter blur-sm pointer-events-none w-full h-full' : 'w-full h-full'}>
        {children}
      </div>

      {showOverlay && (
        <UsageBlurOverlay
          feature={feature}
          usage={usage}
          lastReset={lastReset}
          featureName={featureName}
          onClose={() => {
            window.history.back();
          }}
        />
      )}
    </div>
  );
};

export default UsageGuard;
